enum TabName {
    Updated = 'updated',
    Document = 'document',
    ByCategory = 'by-category'
}

export default TabName;